/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiSchoolItemIdGet } from '../fn/school/api-school-item-id-get';
import { ApiSchoolItemIdGet$Params } from '../fn/school/api-school-item-id-get';
import { apiSchoolOverviewGet } from '../fn/school/api-school-overview-get';
import { ApiSchoolOverviewGet$Params } from '../fn/school/api-school-overview-get';
import { apiSchoolSyncPost } from '../fn/school/api-school-sync-post';
import { ApiSchoolSyncPost$Params } from '../fn/school/api-school-sync-post';
import { ImportResult } from '../models/import-result';
import { School } from '../models/school';
import { SchoolOverviewList } from '../models/school-overview-list';


/**
 * School service
 */
@Injectable({ providedIn: 'root' })
export class SchoolService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSchoolItemIdGet()` */
  static readonly ApiSchoolItemIdGetPath = '/api/school/{item_id}';

  /**
   * Get a school.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSchoolItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSchoolItemIdGet$Response(params: ApiSchoolItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<School>> {
    return apiSchoolItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a school.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSchoolItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSchoolItemIdGet(params: ApiSchoolItemIdGet$Params, context?: HttpContext): Observable<School> {
    return this.apiSchoolItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<School>): School => r.body)
    );
  }

  /** Path part for operation `apiSchoolOverviewGet()` */
  static readonly ApiSchoolOverviewGetPath = '/api/school/overview';

  /**
   * Get school overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSchoolOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSchoolOverviewGet$Response(params?: ApiSchoolOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolOverviewList>> {
    return apiSchoolOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get school overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSchoolOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiSchoolOverviewGet(params?: ApiSchoolOverviewGet$Params, context?: HttpContext): Observable<SchoolOverviewList> {
    return this.apiSchoolOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchoolOverviewList>): SchoolOverviewList => r.body)
    );
  }

  /** Path part for operation `apiSchoolSyncPost()` */
  static readonly ApiSchoolSyncPostPath = '/api/school/sync';

  /**
   * Sync schools.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiSchoolSyncPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSchoolSyncPost$Response(params: ApiSchoolSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
    return apiSchoolSyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Sync schools.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiSchoolSyncPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiSchoolSyncPost(params: ApiSchoolSyncPost$Params, context?: HttpContext): Observable<ImportResult> {
    return this.apiSchoolSyncPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImportResult>): ImportResult => r.body)
    );
  }

}
